module.exports = __webpack_public_path__ + "img/49.63eb64f5.png";